<template>
  <div id="app">
    <header class="header is-fixed">
      <nav-bar>
        <router-link class="home-item nav-item is-tab" :to="{ name: 'home', params: { lang: this.$i18n.locale }  }" exact>{{ $t('common.home') }}</router-link>
        <router-link class="conditions-item nav-item is-tab" :to="{ name: 'conditions', params: { lang: this.$i18n.locale } }">{{ $t('common.conditions') }}</router-link>
        <router-link class="contact-item nav-item is-tab" :to="{ name: 'contact', params: { lang: this.$i18n.locale } }">{{ $t('common.contact') }}</router-link>
        <router-link class="blog-item nav-item is-tab" :to="{ name: 'blog', params: { lang: this.$i18n.locale } }">{{ $t('common.blog') }}</router-link>
      </nav-bar>
    </header>

    <main>
      <router-view></router-view>
    </main>



  <footer class="footer">
    <div class="footer-top">
      <div class="container has-text-centered">
        <h5 class="footer-title">{{ $t('footer.follow') }}</h5>
        <p class="social-icons">
          <a href="https://www.facebook.com/Cinenowapp/" class="social-item">
            <icon glyph="facebook-circle" color="primary"></icon>
          </a>
          <a href="https://twitter.com/cinenowapp" class="social-item">
            <icon glyph="twitter-circle" color="primary"></icon>
          </a>
          <!--<a class="icon" href="#">
                  <i class="fa fa-facebook"></i>
                </a>
                <a class="icon" href="#">
                  <i class="fa fa-twitter"></i>
                </a>
                <a class="icon" href="#">
                  <i class="fa fa-instagram"></i>
                </a>-->
        </p>
        <nav class="navigation level">
          <p class="level-item has-text-centered">
            <router-link :to="{ name: 'home', params: { lang: this.$i18n.locale }  }" exact>{{ $t('common.home') }}</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{ name: 'conditions', params: { lang: this.$i18n.locale } }">{{ $t('common.conditions') }}</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{ name: 'contact', params: { lang: this.$i18n.locale } }">{{ $t('common.contact') }}</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{ name: 'blog', params: { lang: this.$i18n.locale } }">{{ $t('common.blog') }}</router-link>
          </p>
        </nav>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container has-text-centered">
        <p v-html="$t('footer.copyright')"></p>
      </div>
    </div>
  </footer>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import NavBarItem from '@/components/NavBarItem'
import Icon from '@/components/Icon'

export default {
  name: 'app',
  data () {
    return {
    }
  },
  metaInfo () {
    return {
      title: this.$t('home.title'),
      titleTemplate: '%s | Cinenow',

      meta: [
        { name: 'keywords', content: this.$t('common.keywords'), vmid: 'keywords' },
        { property: 'og:title', content: this.$t('home.title'), vmid: 'og:title' },
        { property: 'og:description', content: this.$t('home.description'), vmid: 'og:description' },
        { property: 'og:image', content: `https://cinenow.ca/static/img/og_image_${this.$i18n.locale}.jpg`, vmid: 'og:image' },
        { property: 'og:url', content: `https://cinenow.ca${this.$route.path}`, vmid: 'og:url' }
      ],

      htmlAttrs: {
        lang: this.$i18n.locale
      },

      script: [
        // { innerHTML: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KH4MM37');", vmid: 'gtm' },
        { src: 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit', async: true, defer: true, vmid: 'recaptcha' }
      ],

      noscript: [
         { innerHTML: '<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KH4MM37"height="0" width="0" style="display:none;visibility:hidden"></iframe>', vmid: 'gtm-noscript' }
      ],

      __dangerouslyDisableSanitizers: ['script', 'noscript']
    }
  },
  components: {
    NavBar,
    NavBarItem,
    Icon
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');

@import './assets/styles/_variables.scss';
@import '~bulma/bulma';

.input,
.textarea {
  color: $white;
}

.header.is-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.section {
  background-color: $background;
}

main {
  padding-top: $nav-height;
}

.content h3 {
  color: $purple-bis;
}

// main .section:first-child {
//   padding-top: 0;
// }

.footer {
  background: $purple;
  background: linear-gradient(to right, $purple 0%, $purple-bis 76%, $purple-ter 100%);

  a {
    color: $white;
  }
}

.modal-close {
  top: calc(3.25em + 20px);
}


/*#app {
  color: #2c3e50;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  height: 100%;
}

.footer.segment {
  margin: 2em 0 0;
  height: 100px;
}*/
</style>

<style lang="scss" scoped>
@import './assets/styles/_variables.scss';

.home-item {
  font-weight: $weight-light;
}

.conditions-item {
  font-weight: $weight-normal;
}

.contact-item {
  font-weight: $weight-semibold;
}

.blog-item {
  font-weight: $weight-bold;
}

.footer-title {
  margin-bottom: 1em;
}

.social-icons {
  margin-bottom: 1.5em;

}

.social-item {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin: 0 0.8em;
}

.navigation.level {
  max-width: 400px;
  margin: auto;
}

.footer {
  padding: 0;
}

.footer-top {
  padding: 1.5rem 0;
}

.footer-bottom {
  color: $primary;
  background: $black;
}
</style>




// WEBPACK FOOTER //
// App.vue?4db2691f